import { render } from "./CadastroChamadosView.vue?vue&type=template&id=41ba80f0&scoped=true"
import script from "./CadastroChamadosView.vue?vue&type=script&lang=js"
export * from "./CadastroChamadosView.vue?vue&type=script&lang=js"

import "./CadastroChamadosView.vue?vue&type=style&index=0&id=41ba80f0&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ba80f0"]])

export default __exports__